import { Tag } from '@chakra-ui/react'
import { EStatus } from 'constants/workplan'

interface IStateBadgeProps {
  status: EStatus | number
}

const StateBadge = ({ status }: IStateBadgeProps) => {
  const normalized = Number(status)
  const getBadgeColors = (s: number) => {
    if (s === EStatus.ACTIVE) {
      return {
        backgroundColor: '#E6F3FF',
        borderColor: '#4A90E2',
        textColor: '#2E5BBA'
      }
    }
    return {
      backgroundColor: '#FFF7E6',
      borderColor: '#FFB366',
      textColor: '#E67E22'
    }
  }

  const colors = getBadgeColors(normalized)

  return (
    <Tag
      size="md"
      variant="outline"
      borderRadius="6px"
      px={2}
      py={1}
      fontSize="14px"
      fontWeight={600}
      borderWidth="1px"
      backgroundColor={colors.backgroundColor}
      borderColor={colors.borderColor}
      color={colors.textColor}
      shadow="none"
    >
      {normalized === EStatus.ACTIVE ? 'Active' : 'Inactive'}
    </Tag>
  )
}

export default StateBadge
